import { isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import type { PopoverFooterProps } from '..'

export default (config: {
  props: Pick<PopoverFooterProps, 'dark'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      wrap: {
        justifyContent: 'flex-end',
      },

      content: {
        flex: '1 0 auto',

        [isPhoneInLandscape]: {
          alignItems: 'stretch',
          flexDirection: 'column',
          marginBlockEnd: tokens.spacingGap200,
          width: '100%',
        },
      },

      buttonsWrapper: {
        flex: '0 1 auto',

        'button, a': {
          '&:focus-visible': {
            outlineColor: props.dark ? tokens.focusColorInverse : undefined,
          },
        },

        [isPhoneInLandscape]: {
          alignItems: 'stretch',
          flexDirection: 'column',
          width: '100%',

          'button, a': {
            width: '100%',
          },
        },
      },

      primary: {
        marginInlineStart: tokens.spacingGap200,

        [isPhoneInLandscape]: {
          marginBlockEnd: tokens.spacingGap100,
          marginInline: 0,
        },
      },

      secondary: {
        [isPhoneInLandscape]: {
          margin: '0',
          flex: '0 1 auto',
        },
      },
    },
  } as const
}
